import { Component, Input, OnInit } from '@angular/core';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-deposit-logo',
  templateUrl: './deposit-logo.component.html',
  styleUrls: ['./deposit-logo.component.scss'],
})
export class DepositLogoComponent implements OnInit {
  @Input() paymentType: string;
  @Input() isWithdrawal: boolean;
  @Input() showLogoText: boolean = false;

  public logoText: string;
  public logoImage: string;

  constructor(
    public cashierService: CashierService,
    public withdrawService: WithdrawalService,
    public utils: UtilsService,
  ) {

  }

  ngOnInit() {
    if (this.isWithdrawal) this.getWithdrawalData();
    if (!this.isWithdrawal) this.getVendorData();
  }

  public getPaymentImage(): string {
    const imageUrl: string = `url(${this.utils.getDepositNetworkPath(this.logoImage)})`;
    return imageUrl;
  }

  public getVendorData() {
    this.cashierService.getActiveTypesCategories({ include_types: true }).subscribe((response: any) => {
      if (response.result) {
        // backend cage types make this check awkward (CAGE; CAGEPA)
        this.logoImage = response.payload.filter(
          x => x.code.toUpperCase().startsWith(this.paymentType.toUpperCase())
        )[0].image_url;
        this.logoText = response.payload.filter(
          x => x.code.toUpperCase().startsWith(this.paymentType.toUpperCase())
        )[0].name || '';
      }
    }, (error) => console.error("Credit Card Active Type Error", error));
  }

  public getWithdrawalData() {
    this.withdrawService.getPayoutMethods().subscribe((res: any) => {
      if (res) {
        for (let paymentMethod of res) {
          if (paymentMethod?.PAYMENT_TYPE.code === this.paymentType?.toUpperCase() || paymentMethod?.PAYMENT_TYPE.PAY_TYPE_CAT?.code === this.paymentType?.toUpperCase()) {
            this.logoImage = paymentMethod?.PAYMENT_TYPE.image_url;
            this.logoText = paymentMethod?.PAYMENT_TYPE.name ?? '';
            break;
          }
        }
      }
    })
  }

}
